import { render } from "./XIconSolidMegaphone.vue?vue&type=template&id=3901245c"
import script from "./XIconSolidMegaphone.vue?vue&type=script&lang=js"
export * from "./XIconSolidMegaphone.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidMegaphone.vue"]])

export default __exports__